import React from "react";
import { InputSelect } from "../Inputs";

const SelectBlockHolePosition: React.FC<SelectType<any>> = props => {
  const options = () => {
    return [
      { value: "H", label: "Horizontal" },
      { value: "V", label: "Vertical" }
    ];
  };

  return (
    <InputSelect
      {...props}
      options={options()}
      placeholder="Posição..."
      onClick={props.onChange}
      isClearable={false}
    />
  );
};

export default SelectBlockHolePosition;
